import React from 'react';
import Layout from '../components/Layout';
import Landing from '../components/Landing';
import Projects from '../components/Projects';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Journey from '../components/Journey';
import {graphql, useStaticQuery} from 'gatsby';

export default function Home(props) {
  const [userData, setUserData] = React.useState(
      useStaticQuery(graphql`
            query UserData {
                userJson {
                    navbar {
                        title
                    }
                    contact {
                        email
                        phone
                        location
                        locationLink
                        subtitle
                    }
                    landing {
                        subtitle
                        title
                        img {
                            relativePath
                            childImageSharp {
                                fluid {
                                    ...GatsbyImageSharpFluid
                                }
                            }
                        }
                    }
                    journey {
                        education {
                            course
                            location
                            institute
                            end
                            start
                        }
                        experience {
                            company
                            end
                            location
                            role
                            start
                        }
                    }
                    footer {
                        isAvailable
                        subtitle
                        title
                    }
                    about {
                        name
                        img {
                            relativePath
                            childImageSharp {
                                fluid {
                                    ...GatsbyImageSharpFluid
                                }
                            }
                        }
                        description1
                        description2
                        myInterest
                        myBackground {
                            experience
                            language
                            nationality
                        }
                        profiles {
                            name
                            link
                        }
                    }
                }
            }
        `),
  );

  React.useEffect(() => {
    window.addEventListener('scroll', (_) => {}, true);
    return () => {
      window.removeEventListener('scroll', (_) => {}, true);
    };
  }, []);

  return !userData ? null : (
        <Layout>
          <div className={`block w-screen overflow-hidden`}>
            {props.is404 ? (
                    <>
                      <div className="">
                        <Navbar data={userData.userJson.navbar} />
                        <div className=" bg-404-primary h-screen w-screen relative mb-28">
                          <img
                            className="h-screen-3/4 absolute top-2/4 left-2/4 transform -translate-x-2/4 -translate-y-2/4"
                            src="image/404.png"
                          />
                        </div>
                        <Footer data={userData.userJson.footer} />
                      </div>
                    </>
                ) : (
                    <>
                      <div className="">
                        <Navbar data={userData.userJson.navbar} />
                        <Landing data={userData.userJson.landing} />
                        <Projects />
                        <Journey data={userData.userJson.journey} />
                        <Footer data={userData.userJson.footer} />
                      </div>
                    </>
                )}
          </div>
        </Layout>
    );
}
